<template>
    <div class="mt-3 mb-3 d-flex justify-content-start align-items-center no-print">

        <template v-if="viewMode === 'tabela'">
            <b-button variant="warning" class="mr-2" @click="$emit('voltar-lista-boletins')">
                <svg class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.75 8.75L0.75 4.75M0.75 4.75L4.75 0.75M0.75 4.75H8.75C9.81087 4.75 10.8283 5.17143 11.5784 5.92157C12.3286 6.67172 12.75 7.68913 12.75 8.75C12.75 9.81087 12.3286 10.8283 11.5784 11.5784C10.8283 12.3286 9.81087 12.75 8.75 12.75H6.75" stroke="#2D3439" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Voltar
            </b-button>
            <b-button
                v-if="!disableBotaoGerarPdf"
                class="btn-blue-custom"
                :disabled="disableGeracaoPdf"
                @click="$emit('gerar-pdf-assinatura')"
            >
                <i :class="fluxoInterno ? 'fa fa-upload mr-2' : 'fa fa-print mr-2'"></i>
                {{ textoBotaoGerarPdf }}
            </b-button>
        </template>

        <template v-else-if="viewMode === 'impressao'">
            <b-button variant="warning" class="mr-2" @click="$emit('cancelar-impressao')">
                <svg class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.75 8.75L0.75 4.75M0.75 4.75L4.75 0.75M0.75 4.75H8.75C9.81087 4.75 10.8283 5.17143 11.5784 5.92157C12.3286 6.67172 12.75 7.68913 12.75 8.75C12.75 9.81087 12.3286 10.8283 11.5784 11.5784C10.8283 12.3286 9.81087 12.75 8.75 12.75H6.75" stroke="#2D3439" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Voltar
            </b-button>
            <b-button class="btn-blue-custom mr-2" @click="$emit('baixar-pdf')">
                <svg class="mr-2" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.66667 7.08333H7.5C7.73611 7.08333 7.93403 7.00347 8.09375 6.84375C8.25347 6.68403 8.33333 6.48611 8.33333 6.25V5.41667C8.33333 5.18056 8.25347 4.98264 8.09375 4.82292C7.93403 4.66319 7.73611 4.58333 7.5 4.58333H6.25C6.13889 4.58333 6.04167 4.625 5.95833 4.70833C5.875 4.79167 5.83333 4.88889 5.83333 5V8.33333C5.83333 8.44444 5.875 8.54167 5.95833 8.625C6.04167 8.70833 6.13889 8.75 6.25 8.75C6.36111 8.75 6.45833 8.70833 6.54167 8.625C6.625 8.54167 6.66667 8.44444 6.66667 8.33333V7.08333ZM6.66667 6.25V5.41667H7.5V6.25H6.66667ZM10.8333 8.75C11.0694 8.75 11.2674 8.67014 11.4271 8.51042C11.5868 8.35069 11.6667 8.15278 11.6667 7.91667V5.41667C11.6667 5.18056 11.5868 4.98264 11.4271 4.82292C11.2674 4.66319 11.0694 4.58333 10.8333 4.58333H9.58333C9.47222 4.58333 9.375 4.625 9.29167 4.70833C9.20833 4.79167 9.16667 4.88889 9.16667 5V8.33333C9.16667 8.44444 9.20833 8.54167 9.29167 8.625C9.375 8.70833 9.47222 8.75 9.58333 8.75H10.8333ZM10 7.91667V5.41667H10.8333V7.91667H10ZM13.3333 7.08333H13.75C13.8611 7.08333 13.9583 7.04167 14.0417 6.95833C14.125 6.875 14.1667 6.77778 14.1667 6.66667C14.1667 6.55556 14.125 6.45833 14.0417 6.375C13.9583 6.29167 13.8611 6.25 13.75 6.25H13.3333V5.41667H13.75C13.8611 5.41667 13.9583 5.375 14.0417 5.29167C14.125 5.20833 14.1667 5.11111 14.1667 5C14.1667 4.88889 14.125 4.79167 14.0417 4.70833C13.9583 4.625 13.8611 4.58333 13.75 4.58333H12.9167C12.8056 4.58333 12.7083 4.625 12.625 4.70833C12.5417 4.79167 12.5 4.88889 12.5 5V8.33333C12.5 8.44444 12.5417 8.54167 12.625 8.625C12.7083 8.70833 12.8056 8.75 12.9167 8.75C13.0278 8.75 13.125 8.70833 13.2083 8.625C13.2917 8.54167 13.3333 8.44444 13.3333 8.33333V7.08333ZM5 13.3333C4.54167 13.3333 4.14931 13.1701 3.82292 12.8438C3.49653 12.5174 3.33333 12.125 3.33333 11.6667V1.66667C3.33333 1.20833 3.49653 0.815972 3.82292 0.489583C4.14931 0.163194 4.54167 0 5 0H15C15.4583 0 15.8507 0.163194 16.1771 0.489583C16.5035 0.815972 16.6667 1.20833 16.6667 1.66667V11.6667C16.6667 12.125 16.5035 12.5174 16.1771 12.8438C15.8507 13.1701 15.4583 13.3333 15 13.3333H5ZM5 11.6667H15V1.66667H5V11.6667ZM1.66667 16.6667C1.20833 16.6667 0.815972 16.5035 0.489583 16.1771C0.163194 15.8507 0 15.4583 0 15V4.16667C0 3.93056 0.0798611 3.73264 0.239583 3.57292C0.399306 3.41319 0.597222 3.33333 0.833333 3.33333C1.06944 3.33333 1.26736 3.41319 1.42708 3.57292C1.58681 3.73264 1.66667 3.93056 1.66667 4.16667V15H12.5C12.7361 15 12.934 15.0799 13.0938 15.2396C13.2535 15.3993 13.3333 15.5972 13.3333 15.8333C13.3333 16.0694 13.2535 16.2674 13.0938 16.4271C12.934 16.5868 12.7361 16.6667 12.5 16.6667H1.66667Z" fill="white"/>
                </svg>
                Baixar PDF
            </b-button>
            <b-button class="btn-green-custom" :disabled="disableGeracaoPdf" @click="$emit('proxima-etapa')">
                <i class="fa fa-check"></i> Próxima Etapa
            </b-button>
        </template>

        <template v-else-if="viewMode === 'pdf-viewer'">
            <b-button variant="warning" class="mr-2" :disabled="disableGeracaoPdf" @click="$emit('voltar-para-tabela')">
                <svg class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.75 8.75L0.75 4.75M0.75 4.75L4.75 0.75M0.75 4.75H8.75C9.81087 4.75 10.8283 5.17143 11.5784 5.92157C12.3286 6.67172 12.75 7.68913 12.75 8.75C12.75 9.81087 12.3286 10.8283 11.5784 11.5784C10.8283 12.3286 9.81087 12.75 8.75 12.75H6.75" stroke="#2D3439" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Voltar
            </b-button>
            <b-button class="btn-blue-custom mr-2" :disabled="disableGeracaoPdf" @click="$emit('baixar-pdf')">
                <svg class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13 9V11.6667C13 12.0203 12.8595 12.3594 12.6095 12.6095C12.3594 12.8595 12.0203 13 11.6667 13H2.33333C1.97971 13 1.64057 12.8595 1.39052 12.6095C1.14048 12.3594 1 12.0203 1 11.6667V9M3.66667 5.66667L7 9M7 9L10.3333 5.66667M7 9V1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Baixar PDF
            </b-button>
            <b-button class="btn-green-custom" :disabled="disableGeracaoPdf" @click="$emit('proxima-etapa')">
                <i class="fa fa-check"></i> Próxima Etapa
            </b-button>
        </template>

        <template v-else-if="viewMode === 'upload'">
            <b-button variant="warning" class="mr-2" @click="$emit('voltar-para-impressao')">
                <svg class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.75 8.75L0.75 4.75M0.75 4.75L4.75 0.75M0.75 4.75H8.75C9.81087 4.75 10.8283 5.17143 11.5784 5.92157C12.3286 6.67172 12.75 7.68913 12.75 8.75C12.75 9.81087 12.3286 10.8283 11.5784 11.5784C10.8283 12.3286 9.81087 12.75 8.75 12.75H6.75" stroke="#2D3439" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Voltar
            </b-button>
        </template>
    </div>
</template>

<script>
export default {
    name: 'CronogramaAcoes',
    props: {
        viewMode: {
            type: String,
            required: true,
            default: 'tabela'
        },
        disableEnviar: {
            type: Boolean,
            default: false
        },
        disableGeracaoPdf: {
            type: Boolean,
            default: false
        },
        disableBotaoGerarPdf: {
            type: Boolean,
            default: false
        },
        textoBotaoGerarPdf: {
            type: String,
            default: 'Gerar PDF para Assinatura'
        },
        fluxoInterno: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>
.btn-blue-custom {
    background-color: #2E60AD !important;
    border-color: #2E60AD !important;
    color: #fff !important;
}
.btn-blue-custom:hover {
    filter: brightness(0.9);
}

.btn-green-custom {
    background-color: #23A26D !important;
    border-color: #23A26D !important;
    color: #fff !important;
}
.btn-green-custom:hover {
    filter: brightness(0.9);
}

.btn-green-custom:disabled {
    background-color: #23A26D99 !important;
    border-color: #23A26D99 !important;
    opacity: 1 !important;
    cursor: not-allowed;
}

@media print {
    .no-print {
        display: none !important;
    }
}
</style>
